/**
 * LockIcon Component
 * 
 * Reusable lock icon for premium features.
 * 
 * @param {Object} props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.size] - Icon size ('sm', 'md', 'lg', or number)
 */

export default function LockIcon({ className = '', size = 'md' }) {
  // Map size to dimensions
  const sizeMap = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  }

  const sizeClass = typeof size === 'number' ? `w-${size} h-${size}` : sizeMap[size] || sizeMap.md

  return (
    <svg
      className={`${sizeClass} ${className}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
  )
}
